/* eslint-disable @typescript-eslint/no-var-requires */
import { useLocation } from 'react-router-dom';
import React from 'react'
import Header from './pages/HeaderFolder/Header';
import Footer from './pages/FooterFolder/Footer';
import ScrollToTop from './components/scroll-to-top';
import { error } from 'console';

interface Props {
  children: React.ReactNode;
}


function App(props: Props) {

  const location = useLocation();
  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-white">
      <ScrollToTop />
      <div className="relative min-h-screen bg-cover bg-white">
        <Header />
        <main>
          {props.children}
          {(location.pathname === '/' ||
            location.pathname.includes('/hrl-'))}
          {/* Uncomment this to enable subscribe form again and comment line above  */}
          {/* location.pathname.includes('/hrl-')) && <SubscribeForm />} */}
          <Footer />
        </main>
        
      </div>
    </div>
  );
}

export default App;
